<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
      <v-col cols="12">
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Evaluación psicológica
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form v-model="psicologicaForm">
                <v-row>
                  <v-col cols="12">
                    <v-col>
                      <v-textarea
                        v-model="psicologico.trayectoriaLaboral"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        label="Trayectoria laboral"
                        no-resize
                        rows="20"
                        :rules="required"
                      />
                    </v-col>
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="psicologico.fk_idEvaluador"
                      label="Evaluador"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="evaluadores"
                      item-value="idEvaluador"
                      item-text="evaluador"
                      :rules="required"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model.number="psicologico.experienciaSP"
                      type="number"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Años de experiencia en seguridad pública"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="psicologico.aptoArmaFuego"
                      color="secondary"
                      label="El elemento es apto para portar arma de fuego"
                    />
                    <v-checkbox
                      v-model="psicologico.accidentesArmaFuego"
                      color="secondary"
                      label="El elemento ha tenido accidentes con arma de fuego"
                    />
                    <v-checkbox
                      v-model="psicologico.accidentesPatrulla"
                      color="secondary"
                      label="El elemento ha tenido accidentes con patrulla"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="psicologico.fortalezas"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Fortalezas"
                      no-resize
                      rows="20"
                      :rules="required"
                    />
                    <v-textarea
                      v-model="psicologico.areasOporunidad"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Áreas de oportunidad"
                      no-resize
                      rows="20"
                      :rules="required"
                    />
                    <v-textarea
                      v-model="psicologico.observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Observaciones"
                      no-resize
                      rows="20"
                      :rules="required"
                    />
                    <v-textarea
                      v-model="psicologico.conclusiones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Conclusiones"
                      no-resize
                      rows="20"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="psicologico.fk_idCatDiagnostico"
                      label="Diagnóstico"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="diagnostico"
                      item-value="id"
                      item-text="title"
                      :rules="required"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="motivosResultado"
                      multiple
                      label="Motivo del resultado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="motivoResultado"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-file-input
                      v-model="psicologico.file"
                      label="Adjunto funciones que desempeña"
                      rounded
                      filled
                      background-color="primary"
                      color="secondary"
                      dense
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="psicologico.fk_idCatSemaforoResultado"
                      label="Semáforo de resultado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="semaforoResultado"
                      item-value="id"
                      item-text="nombre"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  md="12"
                  align="center"
                >
                  <v-btn
                    rounded
                    class="mx-8"
                    elevation="8"
                    color="secondary"
                    :loading="loading"
                    :disabled="!psicologicaForm || loading"
                    @click="triggerSaveEvaluacionPsicologica()"
                  >
                    Guardar evaluación
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { circularProgressProps } from '../../components/props/props';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    idExpediente: {
      type: Number,
      required: true,
    },
    idProgramacion: {
      type: Number,
      required: true,
    },
    idDerivacion: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,

      loading: false,
      psicologicaForm: false,

      psicologico: {
        fk_idDerivacion: this.idDerivacion,
        fk_idProgramacion: this.idProgramacion,
        fk_idExpediente: this.idExpediente,
        fk_idEvaluador: null,
        aptoArmaFuego: false,
        experienciaSP: null,
        accidentesArmaFuego: false,
        accidentesPatrulla: false,
        fk_idCatDesempenio: 1,
        fortalezas: '',
        areasOporunidad: '',
        observaciones: '',
        conclusiones: '',
        fk_idCatDiagnostico: null,
        file: null,
        fileFuncionesDesempeña: null,
        fileDatosGenerales: null,
        fileDatosFamiliares: null,
        trayectoriaLaboral: '',
        motivosResultado: [],
        fk_idCatSemaforoResultado: null,
      },

      motivosResultado: [],

      required: [(v) => !!v || 'Este campo es requerido.'],

      overlay: false,
    };
  },

  computed: {
    ...mapGetters('desempeño', {
      desempeño: 'getDesempeño',
    }),
    ...mapGetters('diagnostico', {
      diagnostico: 'getDiagnostico',
    }),
    ...mapGetters('motivoResultado', {
      motivoResultado: 'getMotivoResultado',
    }),
    ...mapGetters('evaluadores', {
      evaluadores: 'getEvaluadores',
    }),

    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),

    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),

    ...mapGetters('datosLaborales', {
      datosLaborales: 'getDatosLaborales',
    }),
  },

  watch: {
    datosLaborales: {
      handler(newValue) {
        if (newValue.length > 0) {
          let text = '';
          newValue.forEach((datoLaboral) => {
            text
                                += `\nEmpresa: ${datoLaboral.empresa}\nPeriodo: ${datoLaboral.periodo}\nPuesto: ${datoLaboral.puesto}\nFunciones que desempeñaba: ${datoLaboral.puesto}\n-------------------------------------------------`;
          });
          this.psicologico.trayectoriaLaboral = text;
        }
      },
    },
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.idExpediente);
    await this.fetchDesempeño();
    await this.fetchDiagnostico();
    await this.fetchMotivoResultado();
    await this.fetchDatosLaborales(this.idExpediente);
    this.overlay = false;
  },

  methods: {
    ...mapActions('desempeño', ['fetchDesempeño']),
    ...mapActions('diagnostico', ['fetchDiagnostico']),
    ...mapActions('motivoResultado', ['fetchMotivoResultado']),
    ...mapActions('evaluacionesPsicologicas', ['saveEvaluacionPsicologica']),
    ...mapActions('expediente', ['fetchExpedienteById']),
    ...mapActions('datosLaborales', ['fetchDatosLaborales']),

    async triggerSaveEvaluacionPsicologica() {
      this.loading = true;

      this.motivosResultado.forEach((motivo) => {
        this.psicologico.motivosResultado.push({
          fk_idCatMotivoResultado: motivo,
        });
      });

      await this.saveEvaluacionPsicologica(this.psicologico);

      this.loading = false;
      this.$router.push('/evaluaciones_psicologicas/personal');
    },
  },
};
</script>
